export const parseVenue = (eventType?: string, venue?: string) =>
  eventType === 'live' && venue ? Number.parseInt(venue, 10) : undefined;
